import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="flex items-center gap-2.5 text-xl md:text-2xl font-heading font-bold text-foreground-950">
          <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
          {icon && (
            <span className="w-6 h-6 flex items-center justify-center text-primary-600">
              <i className={icon}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-500 pl-4">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-s-line"></i>
          </span>
        </Link>
      )}
    </div>
  );
}